
const newModel = () => {
    return {
        truongchuanQuocgiaGiaovienId: null,
        truongchuanQuocgiaId: null,
        tenTruongchuanQuocgia: null,
        idKy: null,
        tenKy: null,
        tongsoGiaovien: 0,
        giaovienNu: 0,
        giaovienDantocThieuso: 0,
        giaovienDatchuan: 0,
        ghiChu: null,
        enabled: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        truongchuanQuocgiaGiaovienId: null,
        truongchuanQuocgiaId: null,
        idKy: null,
        tongsoGiaovien: 0,
        giaovienNu: 0,
        giaovienDantocThieuso: 0,
        giaovienDatchuan: 0,
        ghiChu: null,
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        truongchuanQuocgiaGiaovienId: item.truongchuanQuocgiaGiaovienId,
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        idKy: item.idKy,
        tongsoGiaovien: item.tongsoGiaovien,
        giaovienNu: item.giaovienNu,
        giaovienDantocThieuso: item.giaovienDantocThieuso,
        giaovienDatchuan: item.giaovienDatchuan,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        truongchuanQuocgiaGiaovienId: item.truongchuanQuocgiaGiaovienId,
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        tenTruongchuanQuocgia: item.tenTruongchuanQuocgia,
        idKy: item.idKy,
        tenKy: item.tenKy,
        tongsoGiaovien: item.tongsoGiaovien,
        giaovienNu: item.giaovienNu,
        giaovienDantocThieuso: item.giaovienDantocThieuso,
        giaovienDatchuan: item.giaovienDatchuan,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        truongchuanQuocgiaId: null,
        idKy: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        idKy: item.idKy,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        truongchuanQuocgiaGiaovienId: null,
        truongchuanQuocgiaId: null,
        tenTruongchuanQuocgia: null,
        idKy: null,
        tenKy: null,
        tongsoGiaovien: null,
        giaovienNu: null,
        giaovienDantocThieuso: null,
        giaovienDatchuan: null,
        ghiChu: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

export const truongchuanQuocgiaGiaovienModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


